/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Campaign_PeriodInputs */

const en_directory_promotion_campaign_period = /** @type {(inputs: Directory_Promotion_Campaign_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campaign period`)
};

const zh_directory_promotion_campaign_period = /** @type {(inputs: Directory_Promotion_Campaign_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推广周期`)
};

/**
* | output |
* | --- |
* | "Campaign period" |
*
* @param {Directory_Promotion_Campaign_PeriodInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_campaign_period = /** @type {((inputs?: Directory_Promotion_Campaign_PeriodInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Campaign_PeriodInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_campaign_period(inputs)
	return zh_directory_promotion_campaign_period(inputs)
});
export { directory_promotion_campaign_period as "directory.promotion.campaign_period" }